import {
  Activity,
  Airplay,
  AlertCircle,
  BarChart2,
  Briefcase,
  CheckSquare,
  Clipboard,
  Clock,
  Codesandbox,
  Cpu,
  Compass,
  CreditCard,
  DollarSign,
  Download,
  FastForward,
  File,
  FileMinus,
  Globe,
  Headphones,
  Heart,
  Layers,
  List,
  MapPin,
  MinusCircle,
  Navigation,
  Package,
  PenTool,
  PieChart,
  Settings,
  Shuffle,
  Trello,
  Truck,
  Upload,
  User,
  UserPlus,
  Users,
  XSquare,
  Shield,
  Sliders,
  Share2,
  PauseCircle,
  Droplet,
} from "react-feather";

import { FORMS, MODULES } from "../../const";
import Charge from "./icon/Charge";
import ChargeConfirmationIcon, {
  DocumentManagementIcon,
  InspectionProcessIcon,
  TemplateCreationIcon,
} from "./icon/ChargeConfirmationIcon";
import ChargeType from "./icon/ChargeType";
import EvInvIcon, { EvInvApprovalIcon } from "./icon/EvInv";
import FinanceAnalyticsIcon from "./icon/FinanceAnalyticsIcon";
import GeoManagerIcon from "./icon/GeoIManagerIcon";
import { IssueIcon, ServiceIcon } from "./icon/IssueIcon";
import JobIcon from "./icon/JobIcon";
import JobMonitoringIcon from "./icon/JobMonitoringIcon";
import LiveAnalyticsIcon from "./icon/LiveAnalyticsIcon";
import RequestIcon from "./icon/RequestIcon";
import TaxManagement from "./icon/TaxManagement";
import TransporterInvoiceIcon from "./icon/TransporterInvoiceIcon";
import VehicleTypeIcon from "./icon/VehicleTypeIcon";

/*

  WHEN ADDING ROUTES ADD WITH /
  
  example - /master/employee

*/

// sidebarData.js
const sidebarData = {
  Master: [
    {
      label: "Employee",
      description: "Example Employee Screen",
      module: MODULES.Master,
      form: FORMS.EMPLOYEE.EMP.form,
      icon: Briefcase,
      linkName: "/master/employee",
    },
    {
      label: "Vehicle",
      description: "Example Vehicle Screen",
      module: MODULES.Master,
      form: FORMS.VEHICLE.VEH.form,
      icon: Truck,
      linkName: "/master/vehicle",
    },
    {
      label: "Vehicle Type",
      description: "Manage Vehicle Types",
      module: MODULES.Master,
      form: FORMS.VEHICLE.TYPE.form,
      icon: VehicleTypeIcon,
      linkName: "/master/vehicle-type",
    },
    {
      label: "Black List",
      description: "Example Blacklist Screen",
      module: MODULES.Master,
      form: FORMS.BLACKLIST.BLK.form,
      icon: XSquare,
      linkName: "/master/blacklist",
    },
    {
      label: "Trailers",
      description: "Example Trailers Screen",
      module: MODULES.Master,
      form: FORMS.TRAILERS.TRL.form,
      icon: Package,
      linkName: "/master/trailers",
    },
    {
      label: "Agreement",
      description: "Example Agreement Screen",
      module: MODULES.Master,
      form: FORMS.AGREEMENT.AGR.form,
      icon: File,
      linkName: "/master/agreements",
    },
    {
      label: "Trailers",
      description: "Example Trailers Screen",
      module: MODULES.Master,
      form: FORMS.TRAILERS.TRL.form,
      icon: Package,
      linkName: "/master/trailers",
    },
    {
      label: "Stakeholder",
      description: "Example Stakeholder Screen",
      module: MODULES.Master,
      form: FORMS.STAKEHOLDER.STK.form,
      icon: User,
      linkName: "/master/stakeholder",
    },
    {
      label: "Stakeholder Group",
      description: "Example Stakeholder Group Screen",
      module: MODULES.Master,
      form: FORMS.STAKEHOLDER_GROUP.GRP.form,
      icon: Users,
      linkName: "/master/stakeholder-group-creation",
    },
    {
      label: "Cluster Master",
      description: "Example Cluster Screen",
      module: MODULES.Master,
      form: FORMS.CLUSTER.CLU.form,
      icon: Globe,
      linkName: "/master/cluster-creation",
    },
    {
      label: "Location Management",
      icon: MapPin,
      className: "SubHeader",
      items: [
        {
          label: "Location Creation",
          description: "Location Creation Screen",
          module: MODULES.Master,
          form: FORMS.LOCATION.LOC.form,
          icon: MapPin,
          linkName: "/master/location-creation",
        },
        {
          label: "Location Approval",
          description: "Location Approval Screen",
          module: MODULES.Master,
          form: FORMS.LOCATION_APPROVAL.LOC_APP.form,
          icon: Navigation,
          linkName: "/master/location-approval",
        },
      ],
    },
    {
      label: "Item Creation",
      description: "Item Creation Screen",
      module: MODULES.Master,
      form: FORMS.ITEM.TEM.form,
      icon: List,
      linkName: "/master/item-creation",
    },
    {
      label: "Deduction",
      icon: MinusCircle,
      className: "SubHeader",
      items: [
        // {
        //   label: "Item",
        //   description: "Deduction item Creation Screen",
        //   module: MODULES.Master,
        //   form: FORMS.ITEM.TEM.form,
        //   icon: Info,
        //   linkName: "/master/deduction-item",
        // },
        {
          label: "Approval",
          description: "Deduction Approval Screen",
          module: MODULES.Master,
          form: FORMS.ITEM.APPROVAL.form,
          icon: CheckSquare,
          linkName: "/master/deduction-approval",
        },
      ],
    },
    {
      label: "Call center",
      icon: Headphones,
      className: "SubHeader",
      items: [
        {
          label: "Shift",
          description: "Shift Creation Screen",
          module: MODULES.Master,
          form: FORMS.CALL_CENTER_SHIFT.SHI.form,
          icon: Clock,
          linkName: "/master/call-center-shift",
        },
        {
          label: "Shift Group",
          description: "Shift Group Creation Screen",
          module: MODULES.Master,
          form: FORMS.CALL_CENTER_SHIFT_GROUP.SHF_G.form,
          icon: Users,
          linkName: "/master/call-center-shift-group",
        },
      ],
    },
    {
      label: "Geo Manager",
      description: "Example GeoManager Screen",
      module: MODULES.Master,
      form: FORMS.GEO_MANAGER.GEO.form,
      icon: GeoManagerIcon,
      linkName: "/master/geographical-management",
    },
    {
      label: "Bank",
      description: "Manage Banks",
      module: MODULES.Master,
      form: FORMS.BANK.BANK_MASTER.form,
      icon: DollarSign,
      linkName: "/master/bank",
    },
    {
      label: "Bank Branch",
      description: "Bank Branch Screen",
      module: MODULES.Master,
      form: FORMS.BANK_BRANCH.BNK_BRN.form,
      icon: CreditCard,
      linkName: "/master/bank-branch",
    },
    {
      label: "Grama Niladhari Division",
      description: "Create and Manage Grama Niladhari Divisions",
      module: MODULES.Master,
      form: FORMS.GS_DIVISION.GS.form,
      icon: Compass,
      linkName: "/master/gs-division",
    },
    {
      label: "Police Division",
      description: "Police Division Screen",
      module: MODULES.Master,
      form: FORMS.POLICE_DIVISION.POL.form,
      icon: Shield,
      linkName: "/master/police-division",
    },
  ],
  Transaction: [
    {
      label: "Request",
      icon: RequestIcon,
      className: "SubHeader",
      items: [
        {
          label: "Request Creation",
          description: "Example Request Creation Screen",
          module: MODULES.Transaction,
          form: FORMS.REQUEST.CREATION.form,
          icon: Codesandbox,
          linkName: "/transaction/request-creation",
        },
        {
          label: "Quick Request",
          description: "Example Request Creation Screen",
          module: MODULES.Transaction,
          form: FORMS.QUICK_REQUEST.CREATION.form,
          icon: FastForward,
          linkName: "/transaction/quick-request",
        },
        {
          label: "Request Approval",
          description: "Example Stakeholder Screen",
          module: MODULES.Transaction,
          form: FORMS.REQUEST_APPROVAL.APPROVAL.form,
          icon: CheckSquare,
          linkName: "/transaction/request-approval",
        },
      ],
    },
    {
      label: "Job",
      icon: JobIcon,
      className: "SubHeader",
      items: [
        {
          label: "Job Monitoring",
          description: "Example Stakeholder Screen",
          module: MODULES.Transaction,
          form: FORMS.JOB.MONITOR.form,
          icon: JobMonitoringIcon,
          linkName: "/transaction/job-monitoring",
        },
      ],
    },
    {
      label: "Fuel Request Panel",
      description: "Fuel Request Panel",
      module: MODULES.Transaction,
      form: FORMS.FUEL_REQUEST.HEADER.form,
      icon: Droplet,
      linkName: "/transaction/fuel-request-panel",
    },
    {
      label: "NCR Upload",
      description: "NCR Upload Screen",
      module: MODULES.Transaction,
      form: FORMS.NCR.UPLOAD,
      icon: Upload,
      linkName: "/transaction/ncr-upload",
    },
    {
      label: "Call Center Shift",
      icon: Headphones,
      className: "SubHeader",
      items: [
        {
          label: "Shift Assignment",
          description: "Example Shift Assignment Screen",
          module: MODULES.Transaction,
          form: FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SFH.form,
          icon: UserPlus,
          linkName: "/transaction/call-center-shift",
        },
      ],
    },
    {
      label: "Approvals",
      icon: CheckSquare,
      className: "SubHeader",
      items: [
        {
          label: "Supplier Negotiation",
          description: "Supplier Negotiation Screen",
          module: MODULES.Transaction,
          form: FORMS.APPROVAL.SUPPLIER_NEGOTIATION.form,
          icon: Truck,
          linkName: "/transaction/approval/supplier-negotiation",
        },
      ],
    },
  ],
  Finance: [
    {
      label: "Exchange Rate",
      description: "Exchange Rate Screen",
      module: MODULES.Finance,
      form: FORMS.EXCHANGE_RATE.EXC.form,
      icon: Airplay,
      linkName: "/finance/exchangeRate",
    },
    {
      label: "Rate Manager",
      description: "Rate Manager Screen",
      module: MODULES.Finance,
      form: FORMS.RATE_MANAGER.HEADER.form,
      icon: Layers,
      linkName: "/finance/rate-manager",
    },
    {
      label: "Charges",
      icon: Charge,
      className: "SubHeader",
      items: [
        {
          label: "Charge Creation",
          description: "Charge Creation Screen",
          module: MODULES.Finance,
          form: FORMS.CHARGE_CREATION.HEADER.form,
          icon: DollarSign,
          linkName: "/finance/charge",
        },
        {
          label: "Charge Approval",
          description: "Example Stakeholder Screen",
          module: MODULES.Finance,
          form: FORMS.CHARGE_APPROVAL.HEADER.form,
          icon: ChargeConfirmationIcon,
          linkName: "/finance/charge-confirmation",
        },
      ],
    },
    {
      label: "EV/INV Manager",
      description: "Search and Generate EV/INV",
      module: MODULES.Finance,
      form: FORMS.EV_INV_MANAGER.HEADER.form,
      icon: EvInvIcon,
      linkName: "/finance/ev-inv-generator",
    },
    {
      label: "Payment Hold",
      description: "Payment Hold Screen",
      module: MODULES.Finance,
      form: FORMS.SUPPLIER_PAYMENT_HOLD.HEADER.form,
      icon: PauseCircle,
      linkName: "/finance/supplier-payment-hold",
    },
    {
      label: "Tax Manager",
      description: "Search and Tax Registration",
      module: MODULES.Finance,
      form: FORMS.TAX_MANAGER.HEADER.form,
      icon: TaxManagement,
      linkName: "/finance/tax-management",
    },
    {
      label: "EV/INV Approval",
      description: "View generated EV/INV",
      module: MODULES.Finance,
      form: FORMS.EV_INV_APPROVAL.HEADER.form,
      icon: EvInvApprovalIcon,
      linkName: "finance/ev-inv-approve",
    },
    {
      label: "Charge Type",
      description: "Search and Tax Registration",
      module: MODULES.Finance,
      form: FORMS.TAX_MANAGER.HEADER.form,
      icon: ChargeType,
      linkName: "/finance/charge-type",
    },
    {
      label: "Credit/Debit Note",
      description: "Create and Manage Credit/Debit Notes",
      module: MODULES.Finance,
      form: FORMS.CREDIT_DEBIT.HEADER.form,
      icon: CreditCard,
      linkName: "/finance/credit-debit-note",
    },

    {
      label: "Transporter Invoice",
      description: "View Transporter Invoices",
      module: MODULES.Finance,
      form: FORMS.TRANSPORTER_INVOICE.INVOICE.form,
      icon: TransporterInvoiceIcon,
      linkName: "/finance/transporter-invoice",
    },
    {
      label: "Deduction",
      icon: MinusCircle,
      className: "SubHeader",
      items: [
        {
          label: "Deduction",
          description: "Deduction Creation Screen",
          module: MODULES.Finance,
          form: FORMS.APPROVAL_MANAGER.DEDUCTION_MANAGER,
          icon: Settings,
          linkName: "/finance/deduction-master",
        },
        {
          label: "Approval Process",
          description: "Approval Process Screen",
          module: MODULES.Finance,
          form: FORMS.APPROVAL_MANAGER.APPROVAL_MANAGER,
          icon: Settings,
          linkName: "/finance/approvalProcess",
        },
      ],
    },
    {
      label: "Oracle Process Queue",
      description: "Oracle Process Queue",
      module: MODULES.Finance,
      form: FORMS.ORACLE_PROCESS_QUEUE.ORACLE_PROCESS_QUEUE.form,
      icon: Cpu,
      linkName: "/finance/oracle-process-queue",
    },
  ],
  Fleet: [
    {
      label: "Dashboard",
      description: "Example Dashboard Screen",
      module: MODULES.Fleet,
      form: FORMS.FLEET_DASHBORARD.DASHBORARD.form,
      icon: PieChart,
      linkName: "/fleet/fleet-dashboard",
    },
    {
      label: "Dynamic Template",
      description: "Dynamic Template Creation Screen",
      module: MODULES.Fleet,
      form: FORMS.TEMPLATE.DYNAMIC_TEM.form,
      icon: TemplateCreationIcon,
      linkName: "/fleet/template-create",
    },
    {
      label: "Document Management",
      description: "Document Management Screen",
      module: MODULES.Fleet,
      form: FORMS.FLEET.DOCUMENT_MANAGEMENT.form,
      icon: DocumentManagementIcon,
      linkName: "/fleet/document-management",
    },
    {
      label: "Inspection Process",
      description: "Inspection Process Screen",
      module: MODULES.Fleet,
      form: FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form,
      icon: InspectionProcessIcon,
      linkName: "/fleet/inspection-process",
    },
    {
      label: "Service",
      icon: ServiceIcon,
      className: "SubHeader",
      items: [
        {
          label: "Issues",
          description: "Issue Management Screen",
          module: MODULES.Fleet,
          form: FORMS.FLEET_ISSUE.ISSUE_MANAGEMENT.form,
          icon: IssueIcon,
          linkName: "/fleet/issues",
        },
        {
          label: "Work Order",
          description: "Work Order Screen",
          module: MODULES.Fleet,
          form: FORMS.FLEET_WORK_ORDER.WORK_ORDER.form,
          icon: InspectionProcessIcon,
          linkName: "/fleet/work-order",
        },
      ],
    },
    {
      label: "Favorite Templates",
      icon: Heart,
      className: "SubHeader",
      items: [],
    },
  ],
  MIS: [
    {
      label: "Report Generator",
      description: "Report Generator Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.REPORT_GENERATOR.form,
      icon: File,
      linkName: "/mis/report-generator",
    },
    {
      label: "MIS Report",
      description: "MIS Report Download Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.REPORT.form,
      icon: Download,
      linkName: "/mis/mis-report",
    },
    {
      label: "Audit Report",
      description: "Audit Report Download Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.AUDIT_REPORT.form,
      icon: CheckSquare,
      linkName: "/audit/audit-report",
    },
    {
      label: "Revenue Distribution Report",
      description: "Revenue Distribution Report Download Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.REVENUE_DISTRIBUTION_REPORT.form,
      icon: PieChart,
      linkName: "/revenue/revenue-report",
    },
    {
      label: "Performance Finance Report",
      description: "Performance Finance Report Download Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.PERFORMANCE_FINANCE_REPORT.form,
      icon: Clipboard,
      linkName: "/performance/finance-report",
    },
    {
      label: "Performance Monitoring",
      description: "Performance Monitor Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.PERFORMANCE_MONITOR.form,
      icon: Activity,
      linkName: "/mis/performance-monitor",
    },
    {
      label: "Vehicle In and Out",
      description: "Vehicle In and Out Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.VEHICLE_IN_AND_OUT.form,
      icon: Truck,
      linkName: "/mis/vehicle-in-out",
    },
    {
      label: "Document Delivery Note",
      description: "Document Delivery Note Screen",
      module: MODULES.MIS,
      form: FORMS.MIS.DOCUMENT_DELIVERY_NOTE.form,
      icon: Package,
      linkName: "/mis/document-delivery-note",
    },
    {
      label: "Call Center Performance",
      description: "Call Center Performance",
      module: MODULES.MIS,
      form: FORMS.MIS.CALL_CENTER_PERFORMANCE.form,
      icon: Headphones,
      linkName: "/mis/call-center-performance",
    },
    {
      label: "TMS Dashboard",
      icon: BarChart2,
      className: "SubHeader",
      items: [
        {
          label: "Finance Analytics",
          description: "Finance Analytics",
          module: MODULES.MIS,
          form: FORMS.MIS.METABASE_FINANCE_ANALYTICS.form,
          icon: FinanceAnalyticsIcon,
          linkName: "/mis/finance-analytics",
        },
        {
          label: "Live Analytics",
          description: "Live Analytics",
          module: MODULES.MIS,
          form: FORMS.MIS.METABASE_FINANCE_ANALYTICS.form,
          icon: LiveAnalyticsIcon,
          linkName: "/mis/live-analytics",
        },
      ],
    },
    {
      label: "Deduction",
      description: "Deduction Report",
      module: MODULES.MIS,
      form: FORMS.MIS.DEDUCTION_REPORT.form,
      icon: MinusCircle,
      linkName: "/mis/deduction",
    },
  ],
  Admin: [
    {
      label: "Config",
      icon: Shuffle,
      className: "SubHeader",
      items: [
        {
          label: "Alert",
          description: "Alert Creation Screen",
          module: MODULES.Admin,
          form: FORMS.ALERTS.ALR.form,
          icon: AlertCircle,
          linkName: "/admin/default-alert",
        },
        {
          label: "Option Config",
          description: "Option Config Creation Screen",
          module: MODULES.Admin,
          form: FORMS.ALERTS.ALR.form,
          icon: Trello,
          linkName: "/admin/option-config",
        },
      ],
    },
  ],
  Support: [
    {
      label: "Job Modification",
      description: "Job Modification Screen",
      module: MODULES.Support,
      form: FORMS.SUPPORT.JOB_MODIFICATION.form,
      icon: Briefcase,
      linkName: "/support/job-modification",
    },
    {
      label: "Finance Amendment",
      description: "Finance Amendment Screen",
      module: MODULES.Support,
      form: FORMS.SUPPORT.FINANCE_AMENDMENT.form,
      icon: FileMinus,
      linkName: "/support/finance-amendment",
    },
    {
      label: "Employee Modification",
      description: "Employee Modification Screen",
      module: MODULES.Support,
      form: FORMS.SUPPORT.EMPLOYEE_MODIFICATION.form,
      icon: Users,
      linkName: "/support/employee-modification",
    },
    {
      label: "Vehicle Modification",
      description: "Vehicle Modification Screen",
      module: MODULES.Support,
      form: FORMS.SUPPORT.VEHICLE_MODIFICATION.form,
      icon: Truck,
      linkName: "/support/vehicle-modification",
    },
  ],
};

export default sidebarData;
